"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Context = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Context_module_css_1 = __importDefault(require("./Context.module.css"));
const Subtitle_1 = require("./Subtitle");
const Title_1 = require("./Title/Title");
const Icon_1 = require("./Icon");
const web_core_ui_1 = require("@snapchat/web-core-ui");
function SoundImage(card) {
    // Sound context defaults to an icon if no thumbnail is provided
    if (card.type === "SOUND" && !card.thumbnailUrl) {
        return ((0, jsx_runtime_1.jsx)("div", { className: Context_module_css_1.default.defaultSoundIcon, children: (0, jsx_runtime_1.jsx)(web_core_ui_1.SoundIcon, {}) }));
    }
    if (!card.thumbnailUrl) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(Icon_1.Icon, { iconUrl: card.thumbnailUrl, imageAlt: "Context card" });
}
/**
 * Renders a context card in the Story web player.
 */
function Context(card) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: Context_module_css_1.default.card, "data-testid": "footerCardIcon", children: [(0, jsx_runtime_1.jsx)(SoundImage, { ...card }), (0, jsx_runtime_1.jsxs)("div", { className: Context_module_css_1.default.metadata, children: [card.url ? ((0, jsx_runtime_1.jsx)("a", { href: card.url, className: Context_module_css_1.default.clickableStyle, children: (0, jsx_runtime_1.jsx)(Title_1.Title, { title: card.title }) })) : ((0, jsx_runtime_1.jsx)(Title_1.Title, { title: card.title })), card.subtitle && (0, jsx_runtime_1.jsx)(Subtitle_1.Subtitle, { subtitle: card.subtitle })] })] }));
}
exports.Context = Context;
//# sourceMappingURL=Context.js.map